import React from 'react';
import { Avatar, AvatarFallback } from '../ui/avatar';
import { Badge } from '../ui/badge';

const ACTIVITY_MAP = {
  idle: { label: '', color: 'bg-emerald-400' },
  building: { label: 'Building...', color: 'bg-amber-400 animate-pulse' },
  typing: { label: 'Typing...', color: 'bg-blue-400 animate-pulse' },
  deploying: { label: 'Deploying...', color: 'bg-violet-400 animate-pulse' },
  reviewing: { label: 'Reviewing...', color: 'bg-cyan-400' },
};

const TeamPresenceBar = ({ members = [] }) => {
  // Deduplicate members by id
  const uniqueMembers = members.filter((m, i, arr) => arr.findIndex(x => x.id === m.id) === i);
  if (uniqueMembers.length <= 1) return null;

  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-card border-b border-border" data-testid="team-presence-bar">
      <span className="text-xs text-muted-foreground font-medium">Team</span>
      <div className="flex items-center -space-x-2">
        {uniqueMembers.slice(0, 5).map((m, idx) => {
          const activity = ACTIVITY_MAP[m.activity] || ACTIVITY_MAP.idle;
          return (
            <div key={m.id || idx} className="relative" title={`${m.name} — ${m.activity || 'online'}`}>
              <Avatar className="w-7 h-7 border-2 border-[#0f0f0f]">
                <AvatarFallback className="bg-gradient-to-br from-blue-600 to-violet-600 text-white text-xs font-semibold">
                  {(m.name || 'U')[0].toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <span className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full ${activity.color} border-2 border-[#0f0f0f]`} />
            </div>
          );
        })}
        {uniqueMembers.length > 5 && (
          <div className="w-7 h-7 rounded-full bg-accent border-2 border-[#0f0f0f] flex items-center justify-center">
            <span className="text-xs text-muted-foreground">+{uniqueMembers.length - 5}</span>
          </div>
        )}
      </div>

      {/* Show active builders */}
      {uniqueMembers.filter(m => m.activity && m.activity !== 'idle').map((m, idx) => {
        const act = ACTIVITY_MAP[m.activity] || ACTIVITY_MAP.idle;
        return (
          <Badge key={m.id || idx} className="bg-secondary text-muted-foreground border-input gap-1.5 text-xs" data-testid={`member-activity-${m.id}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${act.color}`} />
            {m.name?.split(' ')[0]} {act.label}
          </Badge>
        );
      })}

      <span className="text-xs text-muted-foreground/70 ml-auto">{uniqueMembers.length} online</span>
    </div>
  );
};

export default TeamPresenceBar;
